const walletPaymentTypes = {
	NEW_TRANSACTION: {
		REQUEST: 'WALLET_PAYMENT_NEW_TRANSACTION_REQUEST',
		SUCCESS: 'WALLET_PAYMENT_NEW_TRANSACTION_SUCCESS',
		FAILURE: 'WALLET_PAYMENT_NEW_TRANSACTION_FAILURE',
	},
	CHECK_BARCODE: {
		REQUEST: 'WALLET_PAYMENT_CHECK_BARCODE_REQUEST',
		SUCCESS: 'WALLET_PAYMENT_CHECK_BARCODE_SUCCESS',
		FAILURE: 'WALLET_PAYMENT_CHECK_BARCODE_FAILURE',
		CLEAR: 'WALLET_PAYMENT_CHECK_BARCODE_CLEAR',
	},
	WALLET_TRANSACTION: {
		REQUEST: 'WALLET_PAYMENT_WALLET_TRANSACTION_REQUEST',
		SUCCESS: 'WALLET_PAYMENT_WALLET_TRANSACTION_SUCCESS',
		FAILURE: 'WALLET_PAYMENT_WALLET_TRANSACTION_FAILURE',
		CLEAR: 'WALLET_PAYMENT_WALLET_TRANSACTION_CLEAR',
	},
	INSUFFICIENT_BALANCE: 'WALLET_PAYMENT_INSUFFICIENT_BALANCE',
	GENERAL_ERROR: 'WALLET_PAYMENT_GENERAL_ERROR',
	CLEAR_AMOUNT: 'WALLET_PAYMENT_CLEAR_AMOUNT',
};

export default walletPaymentTypes;
